export default __webpack_public_path__ + "static/media/play.6fd5b6fc.svg";